import { render, staticRenderFns } from "./BadgeModal.vue?vue&type=template&id=5fa4cd88"
import script from "./BadgeModal.vue?vue&type=script&lang=js"
export * from "./BadgeModal.vue?vue&type=script&lang=js"
import style0 from "./BadgeModal.vue?vue&type=style&index=0&id=5fa4cd88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports